
import React from 'react';

const TermsContent_fr: React.FC = () => (
    <div className="space-y-4 text-sm leading-relaxed text-slate-700" dir="ltr">
        <section>
            <h3 className="text-lg font-bold text-slate-900 mb-2">1. Propriété des recettes et attribution</h3>
            <p>
                En publiant du contenu sur mealPai, vous reconnaissez et acceptez que toute recette ajoutée à partir d'une source externe (y compris, mais sans s'y limiter, des sites Web, des livres de cuisine ou des blogs) qui est identique ou substantiellement similaire à la source originale <strong>doit inclure un lien de référence direct (URL) ou une citation</strong> vers le créateur original si la recette est marquée comme "Publique".
            </p>
        </section>

        <section>
            <h3 className="text-lg font-bold text-slate-900 mb-2">2. Responsabilité de l'utilisateur et obligations</h3>
            <p>
                Les recettes publiques copiées à partir d'une source externe sans crédit ou référence appropriée peuvent constituer une violation des droits de propriété intellectuelle.
            </p>
            <ul className="list-disc pl-5 mt-2 space-y-1">
                <li>
                    <strong>Responsabilité de l'utilisateur :</strong> L'utilisateur publiant le contenu est seul responsable de s'assurer qu'il a le droit de partager le contenu et de fournir l'attribution nécessaire.
                </li>
                <li>
                    <strong>Limitation de responsabilité :</strong> mealPai, ses opérateurs, employés, bénévoles et affiliés (rémunérés ou non) <strong>ne seront pas tenus responsables</strong> des recettes copiées, publiées ou distribuées par les utilisateurs sans crédit approprié ou en violation des lois sur le droit d'auteur.
                </li>
            </ul>
        </section>

        <section>
            <h3 className="text-lg font-bold text-slate-900 mb-2">3. Modifications et usage équitable</h3>
            <p>
                Les utilisateurs sont encouragés à suggérer des modifications, des adaptations ou des améliorations aux recettes. Cependant, ces suggestions et modifications publiées doivent rester dans les limites des lois applicables sur le droit d'auteur. La transformation substantielle d'une recette n'annule pas automatiquement l'exigence d'attribution si l'œuvre principale est dérivée d'une source protégée.
            </p>
        </section>

        <section>
            <h3 className="text-lg font-bold text-slate-900 mb-2">4. Contenu et conduite interdits</h3>
            <p>
                Il est strictement interdit aux utilisateurs de publier du contenu comprenant un langage grossier, offensant, raciste, brutal, haineux ou autrement inapproprié.
            </p>
            <ul className="list-disc pl-5 mt-2 space-y-1">
                <li>
                    <strong>Tolérance zéro :</strong> mealPai maintient une politique de tolérance zéro envers le harcèlement, les discours haineux et le contenu offensant.
                </li>
                <li>
                    <strong>Désactivation de compte :</strong> Tout utilisateur jugé responsable de la publication d'un tel contenu sera tenu personnellement responsable. mealPai se réserve le droit de <strong>désactiver immédiatement le compte</strong> de tout utilisateur violant cette politique, sans préavis.
                </li>
            </ul>
        </section>

        <section>
            <h3 className="text-lg font-bold text-slate-900 mb-2">5. Suppression de contenu</h3>
            <p>
                mealPai se réserve le droit, mais n'assume pas l'obligation, de supprimer tout contenu signalé ou découvert comme étant en violation de ces conditions ou des lois applicables sur la propriété intellectuelle, sans préavis à l'utilisateur.
            </p>
        </section>

        <section>
            <h3 className="text-lg font-bold text-slate-900 mb-2">6. Tarification et abonnements</h3>
            <p>
                Actuellement, mealPai est fourni gratuitement pour les tests et l'usage personnel. Cependant, nous nous réservons le droit d'introduire des plans d'abonnement payants ou des frais de service à l'avenir. L'accès à certaines fonctionnalités premium ou à des limites d'utilisation plus élevées peut nécessiter un abonnement payant. Les utilisateurs seront informés à l'avance de tout changement obligatoire du modèle de tarification.
            </p>
        </section>

        <section>
            <h3 className="text-lg font-bold text-slate-900 mb-2">7. Persistance et perte de données</h3>
            <p>
                Bien que nous fassions des efforts raisonnables pour maintenir la sécurité et l'intégrité de vos données, mealPai est fourni « en l'état » et « selon disponibilité ». Nous <strong>déclinons expressément toute responsabilité en cas de perte de données</strong> (y compris les recettes, les plans de repas ou l'historique du compte) survenant au fil du temps en raison d'erreurs techniques, de migrations de système, de défaillances de la base de données ou de suppression de compte.
            </p>
            <p className="mt-2">
                Les utilisateurs sont vivement encouragés à utiliser périodiquement la fonction <strong>« Exporter les données »</strong> disponible dans le menu pour conserver des sauvegardes personnelles de leurs informations.
            </p>
        </section>

        <section>
            <h3 className="text-lg font-bold text-slate-900 mb-2">8. Utilisation de l&apos;intelligence artificielle (IA) et clause de non-responsabilité</h3>
            <p>
                L&apos;application (mealPai) utilise des technologies d&apos;intelligence artificielle (IA) pour l&apos;analyse de recettes, l&apos;extraction des ingrédients, les avertissements d&apos;allergie et l&apos;analyse de repas adaptée à l&apos;utilisateur. Veuillez noter que cette technologie n&apos;est pas exempte d&apos;erreurs et peut parfois produire des informations incorrectes, incomplètes ou inexactes.
            </p>
            <p className="mt-2">
                Tout contenu généré par l&apos;IA est fourni à titre de recommandation et uniquement à des fins d&apos;information. Les utilisateurs doivent faire preuve de prudence et exercer leur propre jugement indépendant. Il incombe exclusivement à l&apos;utilisateur de vérifier manuellement tous les ingrédients et les avertissements d&apos;allergie (notamment en cas d&apos;allergies graves ou de restrictions alimentaires strictes) avant de préparer ou de consommer tout aliment. Toute confiance accordée à ces informations relève strictement du risque de l&apos;utilisateur.
            </p>
        </section>
    </div>
);

export default TermsContent_fr;
